import React, { useState } from "react";
import logo from "../assets/logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, Globe } from "lucide-react";
import { useTranslation } from "react-i18next";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleProgramClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname === "/") {
      const el = document.getElementById("program-section");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/#program-section");
    }
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleLanguageChange = (lng: "tr" | "de") => {
    i18n.changeLanguage(lng);
  };

  return (
    <header
      className="w-full flex justify-between items-center px-6 sm:px-12 md:px-20 py-4 bg-black z-50 relative"
      style={{ boxShadow: "0px 4px 8px rgba(250, 234, 205, 0.3)" }}
    >
      {/* Logo */}
      <div className="flex items-center z-50">
        <Link to="/">
          <img className="w-28 sm:w-24 md:w-32 cursor-pointer" src={logo} alt="Logo" />
        </Link>
      </div>

      {/* Desktop Menu + Language Switcher */}
      <div className="hidden lg:flex items-center gap-8">
        <nav className="flex gap-8">
          <Link to="/" className="text-white hover:text-brand-red-text transition no-underline">
            {t("nav.home")}
          </Link>
          <a href="/#program-section" onClick={handleProgramClick} className="text-white hover:text-brand-red-text transition no-underline">
            {t("nav.program")}
          </a>
          <Link to="/play" className="text-white hover:text-brand-red-text transition no-underline">
            {t("nav.plays")}
          </Link>
          <Link to="/course" className="text-white hover:text-brand-red-text transition no-underline">
            {t("nav.courses")}
          </Link>
          <Link to="/team" className="text-white hover:text-brand-red-text transition no-underline">
            {t("nav.team")}
          </Link>
          <Link to="/foundation" className="text-white hover:text-brand-red-text transition no-underline">
            {t("nav.foundation")}
          </Link>
        </nav>

        {/* Language Switcher */}
        <div className="text-white flex items-center gap-2 pl-6 border-l border-white/30 ml-4">
          <Globe size={20} />
          <button onClick={() => handleLanguageChange("tr")} className="hover:text-brand-red-text cursor-pointer">TR</button>
          <span>|</span>
          <button onClick={() => handleLanguageChange("de")} className="hover:text-brand-red-text cursor-pointer">DE</button>
        </div>
      </div>

      {/* Mobile Menu Toggle */}
      <button
        onClick={toggleMobileMenu}
        className="lg:hidden text-white z-50"
        aria-label="Menu"
      >
        {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
      </button>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="absolute top-full left-0 w-full bg-black border-t border-b border-brand-red-text flex flex-col items-center py-6 space-y-4 lg:hidden">
          <Link to="/" onClick={() => setIsMobileMenuOpen(false)} className="text-white hover:text-brand-red-text transition">{t("nav.home")}</Link>
          <a href="/#program-section" onClick={handleProgramClick} className="text-white hover:text-brand-red-text transition">{t("nav.program")}</a>
          <Link to="/play" onClick={() => setIsMobileMenuOpen(false)} className="text-white hover:text-brand-red-text transition">{t("nav.plays")}</Link>
          <Link to="/course" onClick={() => setIsMobileMenuOpen(false)} className="text-white hover:text-brand-red-text transition">{t("nav.courses")}</Link>
          <Link to="/team" onClick={() => setIsMobileMenuOpen(false)} className="text-white hover:text-brand-red-text transition">{t("nav.team")}</Link>
          <Link to="/foundation" onClick={() => setIsMobileMenuOpen(false)} className="text-white hover:text-brand-red-text transition">{t("nav.foundation")}</Link>

          {/* Mobile Language Switcher */}
          <div className="flex items-center gap-2 text-white pt-4 border-t border-white/20 mt-2">
            <Globe size={20} />
            <button onClick={() => handleLanguageChange("tr")} className="hover:text-brand-red-text">TR</button>
            <span>|</span>
            <button onClick={() => handleLanguageChange("de")} className="hover:text-brand-red-text">DE</button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;